@if (saveError) {
  <div class="container">
    <app-error-page></app-error-page>
  </div>
}
@if (showError) {
  <div class="out-div">
    <div class="alert-container">
      <mat-icon class="alert-icon" color="warn">error</mat-icon>
      <p class="alert-message">{{ 'error.link_expired' | translate }}</p>
    </div>
  </div>
}
@if (!showError && userCard) {
  <div [ngClass]="!userCard.singleLink ? 'cart-parent-single w-100 h-100' : 'cart-parent-single-content-link'">
    @if (!userCard.singleLink) {
      <div class="main-central-cart w-100">
        <div class="card-lang-selector">
          <app-language-selector></app-language-selector>
        </div>
        <img class="w-100 cover-image-height"
             [src]="userCard.coverImage ? getUserCardImage(userCard.id, ImageType.COVER_IMAGE) : 'assets/images/defBackgroundImage.png'"
             alt="Background img"/>
        <svg class="star-click" (click)="changeFavouriteStatus(userCard.id, userCard.cardId, $event)"
             [ngClass]="{'star-click': clickedOnStar, 'star-click-clicked': !clickedOnStar}" width="36"
             height="36" viewBox="0 0 45 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M30.681 40.8131L30.7405 40.8298L30.8017 40.8389C31.1365 40.8892 31.3999 40.9274 31.5899 40.9533L31.5961 40.9542C31.7395 40.9737 31.9321 41 32.05 41C33.3992 41 34.5822 40.482 35.5571 39.5071C36.558 38.5062 37.04 37.2546 36.9997 35.8236C36.9996 35.8229 36.9996 35.8222 36.9996 35.8214L36.8078 27.9561L42.1133 20.4319C42.4395 19.982 42.684 19.4976 42.835 18.98C42.9771 18.4928 43.05 17.9986 43.05 17.5C43.05 16.4269 42.7362 15.4358 42.1201 14.5528C41.4899 13.6494 40.6221 13.0287 39.5566 12.6981L31.3558 9.9484L25.9456 2.9441C25.4563 2.2936 24.8547 1.79006 24.1388 1.46463C23.4598 1.15599 22.7438 1 22 1C21.2562 1 20.5402 1.15599 19.8612 1.46463C19.1453 1.79006 18.5437 2.2936 18.0544 2.9441L12.6442 9.9484L4.4321 12.7019L4.43208 12.7018L4.42289 12.705C3.36484 13.0713 2.50802 13.7083 1.89593 14.6159C1.30559 15.4912 1 16.4597 1 17.5C1 17.9986 1.07291 18.4928 1.215 18.98C1.36592 19.4974 1.61031 19.9816 1.93635 20.4314L7.1923 27.9055L7.00041 35.8214C7.00039 35.8222 7.00037 35.8229 7.00035 35.8236C6.95999 37.2546 7.44203 38.5062 8.44289 39.5071C9.4178 40.482 10.6008 41 11.95 41C12.1493 41 12.3608 40.9901 12.583 40.9715C12.8505 40.9493 13.1131 40.8945 13.365 40.8003L22 38.3883L30.681 40.8131Z"
            fill="#FACE55" stroke="white" stroke-width="2"/>
        </svg>
        <div class="back-frame">
          <div class="back-frame-mini-1 w-100">
            <!-- PROFILE PICTURES -->
            <div class="back-frame-mini-1-top">
              <img class="profile-pic-style"
                   [src]="userCard.profilePic ? getUserCardImage(userCard.id, ImageType.PROFILE_PIC) : 'assets/svg/defaultUserIcon.svg'"
                   alt="User default picture"/>
              @if (companyLogoExists) {
                <img [src]="getUserCardImage(userCard.id,ImageType.COMPANY_LOGO)" [alt]="'user_card.company_logo' | translate"
                     class="profile-pic-company-style">
              }
              <span class="name-unique-code"
                    [title]="userCard.cardId.length > 18 ? userCard.cardId : ''">
                {{ userCard.cardId.length > 18 ? (userCard.cardId | slice:0:18) + '...' : userCard.cardId }}
              </span>
            </div>

            <!-- PROFILE INFORMATION -->
            <div class="d-flex flex-column justify-content-start gap-2">
              <div class="d-flex flex-row justify-content-between">
                <span class="username-in-frame">
                  {{ userCard.name }} {{ userCard.surname }}
                </span>
                <div class="d-flex flex-row gap-3 align-items-center">
                  @if (userCard.isBusiness) {
                    <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="15" cy="15.2539" r="15" fill="#12314F"/>
                      <mask id="mask0_9436_40359" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="6" y="6"
                            width="18" height="18">
                        <rect x="6" y="6" width="18" height="18" fill="#D9D9D9"/>
                      </mask>
                      <g mask="url(#mask0_9436_40359)">
                        <path
                          d="M8.99805 21.751C8.58555 21.751 8.23242 21.6041 7.93867 21.3104C7.64492 21.0166 7.49805 20.6635 7.49805 20.251V17.251H12.748V18.751H17.248V17.251H22.498V20.251C22.498 20.6635 22.3512 21.0166 22.0574 21.3104C21.7637 21.6041 21.4105 21.751 20.998 21.751H8.99805ZM14.248 17.251V15.751H15.748V17.251H14.248ZM7.49805 15.751V12.001C7.49805 11.5885 7.64492 11.2354 7.93867 10.9416C8.23242 10.6479 8.58555 10.501 8.99805 10.501H11.998V9.00098C11.998 8.58848 12.1449 8.23535 12.4387 7.9416C12.7324 7.64785 13.0855 7.50098 13.498 7.50098H16.498C16.9105 7.50098 17.2637 7.64785 17.5574 7.9416C17.8512 8.23535 17.998 8.58848 17.998 9.00098V10.501H20.998C21.4105 10.501 21.7637 10.6479 22.0574 10.9416C22.3512 11.2354 22.498 11.5885 22.498 12.001V15.751H17.248V14.251H12.748V15.751H7.49805ZM13.498 10.501H16.498V9.00098H13.498V10.501Z"
                          fill="white"/>
                      </g>
                    </svg>
                  }
                  <div
                    class="rating-container d-flex align-items-center justify-content-center px-2 py-1 gap-2 rounded-3"
                    (click)="navigateToRatingPage()"
                  >
                    <mat-icon class="d-flex align-items-center justify-content-center star-icon">star</mat-icon>
                    <span class="rating">{{ cardRating | number:'1.1-1' }}</span>
                    <mat-icon class="d-flex align-items-center justify-content-center arrow-icon">arrow_forward_ios
                    </mat-icon>
                  </div>
                </div>
              </div>
              @if (userCard.specialization || userCard.company) {
                <div class="user-info-frame w-100">
                <span class="profession-cart-text">{{ userCard.specialization }}
                  @if (userCard.specialization && userCard.company) {
                    <span class="profession-cart-text">•</span>
                  } {{ userCard.company }}
                </span>
                  @if (userCard.location) {
                    <span class="profession-cart-location">
                    {{ userCard.location }}
                </span>
                  }
                </div>
              }
              @if (userCard.about) {
                <span class="user-info-text">
                  {{ userCard.about }}
                </span>
              }

              <!-- TAGS -->
              <div class="tag-frame w-100">
                @for (tag of userCard.tags; track tag) {
                  <div class="tag-single-frame">
                    <span class="tag-single-style">{{ tag.name }}</span>
                  </div>
                }
              </div>
            </div>
            <div class="back-frame-mini-2 w-100">
              <button (click)="saveContact()" class="butt-top"><span class="butt-top-inside"><img
                src="assets/svg/saveContactIcon.svg" alt="Save contact icon">{{ 'user_card.save_contact' | translate }}</span></button>
              <button class="butt-bottom" (click)="navigateToPayment()"><span class="butt-bottom-inside">{{ 'user_card.pay' | translate }}</span>
              </button>
              @if (userCard.menuId) {
                <button class="butt-bottom" (click)="navigateToMenu()">
                  <span class="butt-bottom-inside">{{ 'menu' | translate }}</span>
                </button>
              }
              @for (userCardContent of documentUserCardContentList; track userCardContent) {
                <button class="butt-bottom"><span class="butt-bottom-inside"
                                                  [textContent]="userCardContent.linkTitle ? userCardContent.linkTitle : userCardContent.content.name"
                                                  (click)="handleDownload(userCardContent)"></span></button>
              }
            </div>
            @if (isContentViewGrid) {
              <div
                [ngClass]="{'non-visible': otherUserCardContentList.length === 0, 'back-frame-mini-3 w-100': otherUserCardContentList.length > 0}">
                @for (userCardContent of otherUserCardContentList; track userCardContent) {
                  <div class="single-content-frame" (click)="handleLinkClick(userCardContent)">
                    <img
                      [src]="userCardContent.content.contentIcon ? getContentIcon(userCardContent.content.contentIcon) : ''"
                      class="content-icon-frame" alt="">
                    <span
                      class="link-title-style-frame">{{ userCardContent.linkTitle ? userCardContent.linkTitle : userCardContent.content.name }}</span>
                  </div>
                }
              </div>
            } @else {
              <div
                [ngClass]="{'non-visible': otherUserCardContentList.length === 0, 'back-frame-mini-3-v2 w-100': otherUserCardContentList.length > 0}">
                @for (userCardContent of otherUserCardContentList; track userCardContent) {
                  <div class="single-content-frame-v2" (click)="handleLinkClick(userCardContent)">
                    <img
                      [src]="userCardContent.content.contentIcon ? getContentIcon(userCardContent.content.contentIcon) : ''"
                      class="content-icon-frame-v2" alt="">
                    <span
                      class="link-title-style-frame-v2">{{ userCardContent.linkTitle ? userCardContent.linkTitle : userCardContent.content.name }}</span>
                  </div>
                }
              </div>
            }
            @if (otherUserCardContentList.length === 0) {
              <h6 class="back-frame-mini-3-no-data">
                {{ 'user_card.no_links_available' | translate }}
              </h6>
            }
            <div class="back-frame-mini-4 w-100">
              <label class="back-frame-mini-1-line"></label>
              <button class="button-bottom" (click)="onCreateProfile()"><span class="button-bottom-inside">{{ 'user_card.create_my_own_profile' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="single-link-container">
        <div class="single-card-single-link-container">
          <div class="card-lang-selector">
            <app-language-selector></app-language-selector>
          </div>
          <div class="clp-container-single-content-link-wrapper">
            <img src="assets/card-live-preview/single-link-content-background.png"
                 class="clp-container-single-content-link-background">
          </div>
          @for (userCardContent of otherUserCardContentList; track userCardContent) {
            @if (userCardContent.singleLink) {
              <div class="single-content-frame-single-link" (click)="handleLinkClick(userCardContent)">
                <img
                  [src]="userCardContent.content.contentIcon ? getContentIcon(userCardContent.content.contentIcon) : ''"
                  class="content-icon-frame-v2" alt="">
                <span
                  class="link-title-style-frame-v2">{{ userCardContent.linkTitle ? userCardContent.linkTitle : userCardContent.content.name }}</span>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
}
